import React from "react"

import { rhythm } from "../utils/typography"

import Header from './header'

import '../styles/layout.css'

class Layout extends React.Component {
  render() {
    const { children } = this.props
    
    return (
      <div id="layout-container"
        style={{
          maxWidth: rhythm(24),
        }}
      >
        <div id="content-container">
          <Header />
          <main id="main">{children}</main>
        </div>
        <div id="footer-container">
        <footer id="footer" >
          © Amy Henning {new Date().getFullYear()}. Built with&nbsp;<a href="https://www.gatsbyjs.org">Gatsby</a>.
        </footer>
        </div>
      </div>
    )
  }
}

export default Layout
